module.exports = __webpack_public_path__ + "static/media/at.d39fd36a.svg";